// extracted by mini-css-extract-plugin
export default {"rotate":"SpinIcon_rotate__ojCiy","rotation":"SpinIcon_rotation__Ct0xe","limited-cell":"SpinIcon_limited-cell__OoEKP"};